module.exports = __webpack_public_path__ + "img/xlinq-cropped.2eb5403e.svg";